<script lang="ts">
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import { Account } from './Account';
    import { VehicleValidator } from '../Vehicles/VehicleValidator';
    import { VehiclesApi } from '../Vehicles/VehiclesApi';
    import { api } from '../../../stores/api';
    import IconExpander from '../../shared/Icons/IconExpander.svelte';
    import IconFlag from '../../shared/Icons/IconFlag.svelte';
    import InputText from '../../shared/InputText.svelte';
    import ButtonRemove from '../../shared/ButtonRemove.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import Abbreviation from '../../shared/Abbreviation.svelte';
    import SearchForm from '../../shared/SearchForm.svelte';
    import { beforeUpdate, onMount } from 'svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import { captureMessage } from '../../utilities/Sentry';
    import { openModal } from 'svelte-modals';
    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import TemplateErrorGroup from '../../shared/TemplateErrorGroup.svelte';
    import { AccountValidator } from './AccountValidator.js';
    import IconWarehouse from '../../shared/Icons/IconWarehouse.svelte';
    import { AccountApp } from './AccountApp';
    import IconUser from '../../shared/Icons/IconUser.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import { SettingsApi } from '../Settings/SettingsApi';
    import { debug } from '../../../stores/store';
    import SuccessColor from '../../shared/SuccessColor.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import MapLayerList from './MapLayerList.svelte';
    import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';
    import SettingsRow from '../Settings/SettingsRow.svelte';
    import SettingsRowLabel from '../Settings/SettingsRowLabel.svelte';
    import InputNumber from '../../shared/InputNumber.svelte';
    import SettingsRowValue from '../Settings/SettingsRowValue.svelte';
    import { AdminApi } from './AdminApi';
    import Select from '../../shared/Select.svelte';
    import MultiSelectWide from '../../shared/MultiSelectWide.svelte';
    import { app } from '../../../stores/app';
    import Label from '../../shared/Label.svelte';
    import langSettings from '../../../../../locale/langSettings.json';
    import Switch from '../../shared/Switch.svelte';
    import AccountExportImport from './AccountExportImport.svelte';
    import { features } from '../../shared/Features/features';

    export let showHeader: boolean = true;
    export let expandedIndex: string = '';
    export let addMode: boolean = false;
    export let ap: AccountApp;
    export let account: Account;
    export let onAdd: (webuser_id: number) => void;
    export let allMapLayers: MapLayerOneType[];

    let expanded: boolean = false;
    let error: string = '';
    let errorDetails: string = '';
    let loading: boolean = false;
    let validated: boolean = true; // TODO: implement validation
    let disabledLocales: boolean = false;

    let settingReadonly = {
        max_rows_per_file: 'number',
        max_jobs_per_route: 'number',
        compare_scenarios: 'boolean',
        enable_job_modify_time_window_rule: 'boolean',
        minimum_geocoding_quality: 'number',
        micro_grid: 'boolean'
    }

    let allCustomerIds: { id: number; name: string }[] = [];
    let loadingCustomerIds = false;
    let disabledMasterCustomer = false;

    async function loadCustomerIdList() {
        if (allCustomerIds.length > 0) return;
        loadingCustomerIds = true;
        try {
            allCustomerIds = await AdminApi.customerIdList(get(api));
        } catch (e) {
            console.error('Failed to load customer id list', e);
        } finally {
            loadingCustomerIds = false;
        }
    }

    function updateMasterCustomer(enabled: boolean, available_customer_ids: number[]) {
        const cid = account.getCustomerId();
        if (cid === null) return;
        account.setSettingsReadonly({
            ...account.getSettingsReadonly(),
            master_customer: { enabled, available_customer_ids },
        });
        account = account;
        disabledMasterCustomer = true;
        AdminApi.updateSettingsReadonly(
            get(api),
            cid,
            account.getSettingsReadonly()
        ).finally(() => {
            disabledMasterCustomer = false;
        });
    }

    const availableEntriesLocales: { id: string; name: string }[] = Object.entries(
        langSettings.languagesAvailableForUser
    ).map(([id, name]) => {
        return { id, name };
    });

    // 2C4q71Yx
    // maciej.dymowski+test-create1@automapa.pl

    function toggleExpanded() {
        console.log('toggleExpanded');
        expandedIndex = expandedIndex === account.innerId ? '' : account.innerId;
        expanded = expandedIndex === account.innerId || addMode;
    }

    function updateSettingsReadonly(key: string, value: any) {
        let updatedSetting: any = {};
        updatedSetting[key] = value;
        account.setSettingsReadonly({
            ...account.getSettingsReadonly(),
            ...updatedSetting
        });
        AdminApi.updateSettingsReadonly(
            get(api),
            account.getCustomerId(),
            account.getSettingsReadonly()
        );
    }

    onMount(() => {
        console.log('AccountOne onMount');
        if (account.getSettingsReadonly()?.master_customer?.enabled) {
            loadCustomerIdList();
        }
    });

    console.log('AccountOne, account:', account);

    $: expanded = expandedIndex === account.innerId || addMode;

    $: validated = AccountValidator.validateAll(account);
</script>

{#if $debug}
    <div>
        account.get: {JSON.stringify(account.get())}
    </div>
{/if}

{#if showHeader}
    <div class="list-element vehicle-header list-element-header">
        <div class="vehicle_icon"></div>
        <div class="name">{$_('Account name')}</div>
        <div class="email">{$_('E-mail')}</div>
        <div class="expiration-date">{$_('Expiration date')}</div>
    </div>
{/if}

{#if !expanded}
    <div class="list-element vehicle-header list-element-data">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="vehicle_icon"
            on:click={() => {
                toggleExpanded();
            }}
        >
            <IconUser scale={0.7} />
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="customer-id"
            style="line-height: 14px;"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getCustomerId()}
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="name"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getName()}
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="email"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getEmail()}
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="expiration-date"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getExpirationDate() ?? $_('bezterminowo')}
        </div>

        <div class="is-expired" title="is account expired?">
            {#if account.isExpired() === true}
                <ErrorColor>EXPIRED</ErrorColor>
            {:else if account.isExpired() === false}
                <SuccessColor>ACTIVE</SuccessColor>
            {:else}
                <WarningColor>???</WarningColor>
            {/if}
        </div>

        <div class="expand-trigger">
            <IconExpander
                isOpen={expanded}
                on:click={() => {
                    toggleExpanded();
                }}
            />
        </div>
    </div>
{/if}

{#if expanded}
    <div class="vehicle-expanded-container">
        <TemplateErrorGroup {error} {errorDetails}>
            <div class="vehicle-header">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="vehicle_icon"
                    on:click={() => {
                        toggleExpanded();
                    }}
                >
                    <IconUser scale={0.7} />
                </div>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="customer-id"
                    on:click={() => {
                        toggleExpanded();
                    }}
                >
                    {#if !addMode}
                        ({account.getCustomerId()})
                    {/if}
                </div>
                <div class="name">
                    <InputText
                        value={account.getName()}
                        valid={AccountValidator.isNameValid(account) === ''}
                        style="width: 100%"
                        disabled={!addMode}
                        on:change={event => {
                            if (event?.target) {
                                account.setName(event?.target?.value || '');
                                account = account;
                                if (!addMode) {
                                    ap.save(account);
                                }
                            }
                        }}
                        on:keyup={event => {
                            account.setName(event?.target?.value || '');
                            account = account;
                        }}
                    />
                </div>
                <div class="email" style="padding: 3px 3px;">
                    <InputText
                        value={account.getEmail()}
                        valid={AccountValidator.isEmailValid(account) === ''}
                        disabled={!addMode}
                        style="width: 100%"
                        on:change={event => {
                            if (event?.target) {
                                account.setEmail(event?.target?.value || '');
                                account = account;
                                if (!addMode) {
                                    ap.save(account);
                                }
                            }
                        }}
                        on:keyup={event => {
                            account.setEmail(event?.target?.value || '');
                            account = account;
                        }}
                    />
                </div>
                <div class="expiration-date">
                    <Switch
                        label={$_('')}
                        checked={account.getExpirationDate() !== null}
                        on:change={ev => {
                            console.log('Switch onChange, checked:', ev.detail.checked);
                            if (!ev.detail.checked) {
                                account.setExpirationDate(null);
                            } else {
                                // set to 30 days from now
                                const now = new Date();
                                now.setDate(now.getDate() + 30);
                                const year = now.getFullYear();
                                const month = (now.getMonth() + 1).toString().padStart(2, '0');
                                const day = now.getDate().toString().padStart(2, '0');
                                account.setExpirationDate(`${year}-${month}-${day}`);
                            }
                            account = account;
                            if (!addMode) {
                                AdminApi.updateExpirationDate(
                                    get(api),
                                    account.getCustomerId(),
                                    account.getExpirationDate()
                                ).catch(err => {
                                    console.error(err);
                                    alert($_(err));
                                });
                            }
                        }}
                    />
                    <SelectDay
                        day={account.getExpirationDate()}
                        minDay={null}
                        valid={AccountValidator.isExpirationDateValid(account) === '' || account.getExpirationDate() === null}
                        autoApply={true}
                        disabled={account.getExpirationDate() === null}
                        onChange={async day => {
                            account.setExpirationDate(day);
                            account = account;
                            if (!addMode) {
                                await AdminApi.updateExpirationDate(
                                    get(api),
                                    account.getCustomerId(),
                                    day
                                ).catch(err => {
                                    console.error(err);
                                    alert($_(err));
                                });
                                ap = await ap.prepareData(get(api));
                            }
                        }}
                    />
                </div>

                <div class="is-expired">
                    {#if !addMode}
                        {#if account.isExpired() === true}
                            <ErrorColor>EXPIRED</ErrorColor>
                        {:else if account.isExpired() === false}
                            <SuccessColor>ACTIVE</SuccessColor>
                        {:else}
                            <WarningColor>???</WarningColor>
                        {/if}
                    {/if}
                </div>

                <div class="expand-trigger">
                    {#if !addMode}
                        <IconExpander
                            isOpen={expanded}
                            on:click={() => {
                                toggleExpanded();
                            }}
                        />
                    {/if}
                </div>
            </div>
        </TemplateErrorGroup>

        {#if !addMode}
            <div style="padding:20px 10px;">
                <TemplateErrorGroup error="">
                    {#each Object.entries(settingReadonly) as [key, type]}
                        <SettingsRow>
                            <SettingsRowLabel>
                                {$_(key)}
                            </SettingsRowLabel>
                            <SettingsRowValue>
                                {#if type === 'number'}
                                    <InputNumber
                                        style="max-width: 120px; width: 120px;"
                                        value={account
                                            .getSettingsReadonly()
                                            ?.[key]?.toString() ?? ''}
                                        on:change={e => {
                                            if (
                                                z.coerce.number().safeParse(e.target?.value).success ===
                                                false
                                            ) {
                                                return;
                                            }
                                            updateSettingsReadonly(key, z.coerce.number().parse(e.target?.value));
                                        }}
                                    />
                                {:else if type === 'boolean'}
                                    <Switch
                                        checked={account.getSettingsReadonly()?.[key]}
                                        label=""
                                        on:change={e => {
                                            updateSettingsReadonly(key, e.detail.checked);
                                        }}
                                    />
                                {/if}
                            </SettingsRowValue>
                        </SettingsRow>
                    {/each}
                </TemplateErrorGroup>
            </div>
        {/if}

        {#if addMode}
            <div style="padding:20px 10px;">
                <TemplateErrorGroup error="">
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Customer ID')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <Select
                                selected=""
                                items={[
                                    { id: '', label: '(nowy customer)' },
                                    ...ap.getCustomerIdsAsItems(),
                                ]}
                                onChange={v => {
                                    if (
                                        z.coerce.number().nullable().catch(null).safeParse(v)
                                            .success === false
                                    ) {
                                        console.log('Select onChange, invalid value: ', v);
                                        return false;
                                    }
                                    console.log('Select onChange', v);
                                    account.setCustomerId(
                                        z.coerce.number().nullable().catch(null).parse(v)
                                    );
                                    account = account;
                                    return true;
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                </TemplateErrorGroup>
            </div>
        {/if}

        {#if !addMode}
            <div
                style="display: flex; justify-content: flex-start; align-items: center; padding: 20px;"
            >
                <MapLayerList {allMapLayers} bind:account />
            </div>

            <div
                style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; padding: 20px;"
            >
                <div style="font-size: 14px; padding: 2px 5px;">
                    <Label>Available languages</Label>
                </div>
                <div>
                    <MultiSelectWide
                        availableEntries={availableEntriesLocales}
                        selectedIds={account.getSettingsReadonly()?.enabled_locales ?? []}
                        disabled={disabledLocales}
                        onChange={selectedIds => {
                            console.log('MultiSelectWide onChange', selectedIds);
                            account.setEnabledLocales(selectedIds);
                            account = account;
                            disabledLocales = true;
                            AdminApi.updateSettingsReadonly(
                                get(api),
                                account.getCustomerId(),
                                account.getSettingsReadonly()
                            ).finally(() => {
                                disabledLocales = false;
                            });
                        }}
                    />
                </div>
            </div>

            <div
                style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; padding: 20px;"
            >
                <div style="font-size: 14px; padding: 2px 5px; margin-bottom: 8px;">
                    <Label>{$_('master_customer_view_label')}</Label>
                </div>
                <SettingsRow>
                    <SettingsRowLabel>{$_('enable_for_this_account')}</SettingsRowLabel>
                    <SettingsRowValue>
                        <Switch
                            disabled={disabledMasterCustomer}
                            checked={account.getSettingsReadonly()?.master_customer?.enabled ?? false}
                            label=""
                            on:change={async e => {
                                const enabled = e.detail.checked;
                                const currentIds = account.getSettingsReadonly()?.master_customer?.available_customer_ids ?? [];
                                if (enabled) {
                                    await loadCustomerIdList();
                                }
                                updateMasterCustomer(enabled, currentIds);
                            }}
                        />
                    </SettingsRowValue>
                </SettingsRow>
                {#if account.getSettingsReadonly()?.master_customer?.enabled}
                    <div style="margin-top: 8px; width: 100%;">
                        <div style="font-size: 12px; color: #666; padding: 2px 5px; margin-bottom: 4px;">
                            {$_('master_customer_warning')}
                        </div>
                        {#if loadingCustomerIds}
                            <div style="padding: 4px 5px; font-size: 12px;">{$_('loading')}</div>
                        {:else}
                            {#key allCustomerIds}
                                <MultiSelectWide
                                    availableEntries={allCustomerIds.map(c => ({ id: String(c.id), name: `#${c.id} - ${c.name}` }))}
                                    selectedIds={(account.getSettingsReadonly()?.master_customer?.available_customer_ids ?? []).map(String)}
                                    disabled={disabledMasterCustomer}
                                    minAllowedSelectedItems={0}
                                    onChange={selectedIds => {
                                        const ids = selectedIds.map(Number);
                                        const enabled = account.getSettingsReadonly()?.master_customer?.enabled ?? false;
                                        updateMasterCustomer(enabled, ids);
                                    }}
                                />
                            {/key}
                            {@const _cid = account.getCustomerId()}
                            {#if _cid !== null && !(account.getSettingsReadonly()?.master_customer?.available_customer_ids ?? []).includes(_cid)}
                                <div style="margin-top: 6px; padding: 2px 5px;">
                                    <WarningColor>{$_('master_customer_self_include_warning', { values: { customerId: _cid } })}</WarningColor>
                                </div>
                            {/if}
                        {/if}
                    </div>
                {/if}
            </div>
        {/if}

        {#if !addMode && $features?.feature_customer_account_export}
            {@const _exportCustomerId = account.getCustomerId()}
            {#if _exportCustomerId !== null}
                <div
                    style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; padding: 20px;"
                >
                    <AccountExportImport customerId={_exportCustomerId} />
                </div>
            {/if}
        {/if}

        {#if addMode}
            <div
                style="display: flex; justify-content: flex-end; align-items: flex-end; padding: 20px;"
            >
                <div style="display: flex; align-items: center;column-gap: 30px;">
                    <span style="font-size: 14px;">
                        <LinkSmallBlack
                            text={$_('Cancel')}
                            on:click={() => {
                                addMode = false;
                            }}
                        />
                    </span>
                    <ButtonMain
                        text={$_('Add account')}
                        disabled={loading || !validated}
                        on:click={() => {
                            error = '';
                            loading = true;
                            // SettingsApi.createDemoAccount(
                            //     get(api),
                            //     account.getName(),
                            //     account.getEmail(),
                            //     account.getExpirationDate()
                            // )
                            ap.create(get(api), account)
                                .then(accountResponse => {
                                    // copy accountResponse.user_password to clipboard
                                    if (navigator.clipboard) {
                                        navigator.clipboard
                                            .writeText(accountResponse.user_password)
                                            .then(() => {
                                                console.log('Password copied to clipboard');
                                                alert(
                                                    'Account created, please write down this password (or get from clipboard): ' +
                                                        accountResponse.user_password
                                                );
                                            })
                                            .catch(err => {
                                                console.error('Could not copy text: ', err);
                                                alert(
                                                    'Account created, please write down this password: ' +
                                                        accountResponse.user_password
                                                );
                                            });
                                    } else {
                                        console.warn('Clipboard API not available');
                                        alert(
                                            'Account created, please write down this password: ' +
                                                accountResponse.user_password
                                        );
                                    }
                                    // addMode = false;
                                    onAdd(accountResponse.webuser_id);
                                })
                                .catch(err => {
                                    error = $_('Cannot save this account');
                                    console.warn('Cannot save this account', err);
                                    alert($_(err));
                                    errorDetails = err;
                                })
                                .finally(() => {
                                    loading = false;
                                });
                        }}
                    />
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .vehicle-header {
        display: grid;
        grid-template-columns: 30px 60px 1fr 1fr 160px 50px 30px;
        grid-template-rows: auto;
        line-height: 20px;
        padding: 2px 0;
        /*background-color: #cfa516;*/
        grid-template-areas: 'vehicle_icon customer-id name email expiration-date is-expired expand-trigger';
        align-items: center;
        column-gap: 5px;
    }
    .vehicle-header .vehicle_icon {
        grid-area: vehicle_icon;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vehicle-header .name {
        grid-area: name;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
        /*overflow: hidden;*/
        /*line-height: 13px;*/
    }
    .expiration-date {
        grid-area: expiration-date;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vehicle-header .email {
        grid-area: email;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 5px 0;
        cursor: pointer;
        line-height: 13px;
        overflow: hidden;
    }
    .vehicle-header .expand-trigger {
        grid-area: expand-trigger;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .vehicle-expanded-container {
        background-color: var(--selected-item-background);
        /*background-color: #f92672;*/
    }
    .vehicle-expanded-container .vehicle-header {
        grid-template-rows: 41px;
    }
</style>
